export default {
  UPDATE_USERINFO (state, userInfo) {
    state.currentUserInfo = userInfo;
  },
  UPDATE_ISJUMPED (state, isJumped) {
    state.isJumped = isJumped;
  },
};
